export function getFirstError(rootNode) {
  const queue = [rootNode]
  while (queue.length) {
    const node = queue.shift()
    if (node.ref !== undefined) {
      return node
    } else if (node instanceof Object) {
      const children = Object.values(node)
      if (children.length) {
        queue.push(...children)
      }
    }
  }
  return null
}

export function goToFirstError(errors, setBimestreActivo) {
  const first_error = getFirstError(errors)
  if (!first_error) return

  const bimestre = first_error.ref.name[8]
  setBimestreActivo(Number(bimestre))

  first_error.ref.scrollIntoView(false)
  first_error.ref.focus()
}

